import { useEffect, useState } from "react";

export const useTimer = (seconds: number) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  //This is a countdown timer
  useEffect(() => {
    if (timeLeft === 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  return {
    timeLeft,
    setTimeLeft,
  };
};
